import { LF } from '@/i18n/LF';
import i18n from '@/i18n/config';

export function booleanYesNoFilter(value: boolean) {
  return value ? i18n.t(LF.Yes) : i18n.t(LF.No);
}
